export default {
    // C
    copyFailed: 'Could not copy the link.',
    copyLink: 'Copy link',

    // L
    linkCopied: 'Link copied',

    // P
    participants: '{n} participant | {n} participants',

    // R
    ready: 'Recording ready',
    recording: 'Recording',

    // S
    submitVideo: 'Submit video',

    // V
    view: 'View recording',
}
